KenshooReporterDirective = ->
  restrict: "A"
  replace: true
  template: '<iframe style="position: absolute; left: -1000px; top: -1000px" height="0" width="0" frameborder="0"></iframe>',
  link: (scope, element, attrs) ->

    action_map =
      personal_submit:                'personal_submit'
      vehicle_submit:                 'vehicle_submit'
      rates_terms_submit:             'rates_submit'
      contract_submit:                'contract_submit'
      bank_account_submit:            'bank_submit'
      additional_information_submit:  'addinfo_submit'

    scope.$on 'customer_application:data', (event, data) ->
      @id = data.customer_application.id
      @token = data.config.kenshoo.token
      @server = data.config.kenshoo.server
      @referrer = document.referrer

    scope.$on 'conversion:action', (event, action, page) ->
      formatted_action = action_map["#{page}_#{action}"]
      if @server && @token
        element.attr 'src', "https://#{@server}/media/redir.php?track=1&token=#{@token}&type=#{formatted_action}&val=0.0&orderId=#{@id}&promoCode=&valueCurrency=USD&ref=#{@referrer}"


angular.module("avant.kenshooReporter").directive("kenshooReporter", KenshooReporterDirective)
